// features and associated entities
export const Features = [
  { name: "Dashboard", label: "Dashboard", specialPermissions: ["Read"] },
  { name: "Fees", label: "Fees", specialPermissions: ["Read"] },
  { name: "Students Listing", label: "Students Listing", specialPermissions: ['Read'] },
  { name: "Offline Payments", label: "Offline Payments", specialPermissions: ["Create"] },
  { name: "Payments", label: "Fees Report", specialPermissions: ["Read"]},
  { name: "User", label: "Users", Write: ["Roles and Permissions", "User"] },
  { name: "Roles and Permissions", label: "Roles and Permissions" },
  { name: "User Profile", label: "User Profile", specialPermissions: ["Read", "Update"] },
];


